import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { objectKeysSnakeToCamel } from "@/utils/helpers";
import { CasesApi } from "@socotec.io/atm-back-sdk";
import { sdkDatesToStrings, sdkStringsToDates } from "@/api/utils/sdk";

const api = new CasesApi(atmBackConfiguration);

const DATE_FIELDS = ["buildPermitSubmissionDate", "buildPermitIssuanceDate"];
const DATETIME_FIELDS = ["reportDownloadDate"];

const DATE_FILTER_KEYS = ["rfctStart", "rfctEnd", "rfct6Start", "rfct6End"];

const toListParams = (query = {}) => {
  const params = objectKeysSnakeToCamel(query);
  for (const key of DATE_FILTER_KEYS) {
    if (params[key]) params[key] = new Date(params[key]);
  }
  return params;
};

const readCase = (caseInfo) =>
  sdkDatesToStrings(caseInfo, {
    dates: DATE_FIELDS,
    datetimes: DATETIME_FIELDS,
  });
const writeCase = (caseData) => sdkStringsToDates(caseData, [...DATE_FIELDS, ...DATETIME_FIELDS]);

export const retrieveCaseInfoByCaseNumber = async (caseNumber, failIfNoFound = false) => {
  try {
    return readCase(await api.byCaseNumber({ caseNumber }));
  } catch (error) {
    if (!failIfNoFound && error?.response?.status === 404) {
      return undefined;
    }
    throw error;
  }
};

export const updateCaseInfo = async (caseData) => {
  const { atmUuid, ...rest } = caseData;
  const updated = await api.partialUpdate({
    uuid: atmUuid,
    patchedCaseWriteRequest: writeCase(rest),
  });
  return readCase(updated);
};

export const synchroniseCaseMissions = async (caseData, force) => {
  return await api.synchroniseMissions({ uuid: caseData.atmUuid, force });
};

export const fetchCases = async (query = {}) => {
  const response = await api.list(toListParams(query));
  return { ...response, results: response.results.map(readCase) };
};
